import { Component, Input } from '@angular/core';
import { CreditsafeData } from '../creditsafe.model';

@Component({
  selector: 'app-creditsafe-commentaries',
  templateUrl: './creditsafe-commentaries.component.html',
  styleUrls: ['./creditsafe-commentaries.component.scss']
})
export class CreditsafeCommentariesComponent {
  @Input() element: CreditsafeData = new CreditsafeData();
}
